// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
   firebase: {
    apiKey: "AIzaSyDpcDpIdev11aWzGIj_Y860Rwn4W1bhWMo",
    authDomain: "regaladiplomas.firebaseapp.com",
    databaseURL: "https://regaladiplomas.firebaseio.com",
    projectId: "regaladiplomas",
    storageBucket: "regaladiplomas.appspot.com",
    messagingSenderId: "1057409148009",
    appId: "1:1057409148009:web:acfb3d438fd8bfed88aef8"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
